<template>
  <section>
    <v-container>
      <v-row v-if="!isLoading" justify="center">
        <v-col cols="10" v-if="success">
          <v-alert outlined type="success" text>
            <h2 class="text-h5 mb-5 text-center">
              Usuario verificado
            </h2>
            <p class="mt-5 text-paragraph text-center">
              Su usuario ha sido verificado exitosamente.
            </p>
          </v-alert>
        </v-col>
        <v-col cols="10" v-else>
          <v-alert outlined type="error" text>
            <h2 class="text-h5 mb-5 text-center">
              No se pudo verificar el usuario
            </h2>
            <p class="mt-5 text-paragraph text-center">
              {{ errorMessage }}
            </p>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import axios from "axios";

export default {
  // async asyncData({ params }) {
  //     const token = params.token;
  //     return { token };
  // },
  data() {
    return {
      isLoading: true,
      id: null,
      expires: "",
      signature: "",
      errorMessage:
        "El proceso de verificacion ha fallado, por favor intente nuevamente",
      success: false,
    };
  },

  mounted() {
    this.id = this.$route.query.id;
    this.expires = this.$route.query.expires;
    this.signature = this.$route.query.signature;
    this.verifiedCode();
    // console.log("expires", this.$route.query.expires);
    // console.log("signature", this.$route.query.signature);
  },

  methods: {
    async verifiedCode() {
      this.isLoading = true;
      try {
        // /subscribers/email/verify/3?expires=1635397736&signature=09dd1d698f5e46f254d1cfc00fbcfd427e1f0a6b6eac4d0c6d956d7bc3ce3a6b
        const { data } = await axios.get(
          `api/subscribers/email/verify/${this.id}`,
          {
            params: {
              expires: this.expires,
              signature: this.signature,
            },
          }
        );
        // console.log("data", data);
        this.success = true;
      } catch (err) {
        // console.log("err1", err);
        // console.log("err2", err.response);
        if (err.response) this.errorMessage = err.response.data.error.message;
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
